import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Stick from '../../../es';
import Regression from './Regression';
export default function TransportToFixedContainer() {
    const [isOpen, setIsOpen] = useState(false);
    const [container, setContainer] = useState();
    return (_jsxs(Regression, { allBrowsers: true, fixed: true, version: "2.2.0", title: "Transport to fixed position container", description: "The stick should be positioned correctly when transported to a container with `position: fixed`", children: [_jsx("button", { onClick: () => setIsOpen(!isOpen), children: isOpen ? 'close fixed container' : 'open fixed container' }), ' ', "(The fixed container will open at the top left. The sticked node should be attached correctly regardless of the page scroll position)", isOpen && (_jsx("div", { style: {
                    position: 'fixed',
                    top: 20,
                    left: 20,
                    padding: 32,
                    backgroundColor: 'white',
                    border: '1px solid silver',
                    zIndex: 100,
                }, ref: (node) => setContainer(node || undefined), children: _jsx(Stick, { transportTo: container, node: "Yes, here it is!", children: _jsx("div", { children: "There should be a line of text below me" }) }) }))] }));
}
